import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BundleForCreation, BundlesRepositoryService, ConfigurationState } from 'reg-hub-common';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'app-add-bundles',
    templateUrl: './add-bundles.component.html',
    styleUrl: './add-bundles.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AddBundlesComponent implements OnInit {
  private readonly transloco = inject(TranslocoService);
  isSaving: boolean = false;
  newBundle: BundleForCreation = {
    name: "",
    description: ""
  }

  constructor(
    private bundlesService: BundlesRepositoryService,
    private configurationState: ConfigurationState,
    private messageService: ToastrService,
    private router: Router) {

  }
  
  ngOnInit(): void {
    this.configurationState.getCorporationID().then(corporationID => {
      this.bundlesService.populateBaseLink([corporationID]);
    })
  }

  saveBundle() {
    this.isSaving = true;
    this.bundlesService.createBundle(this.newBundle).subscribe({
      next: bundle => {
        this.isSaving = false;
        this.router.navigate(['bundles', bundle.id]);
        
      },
      error: err => {
        console.error(err);
        this.isSaving = false;
        this.messageService.error(this.transloco.translate('bundles.failedToSaveBundle'));
      },
    })
  }
}
